import React from 'react';
import { ClickAwayListener, Menu, MenuProps } from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './AppMenu.styles';
import theme from '../../../styles/theme';

interface AppMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  align?: 'top' | 'bottom';
  anchorOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'right' };
  transformOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'right';
  };
  children: React.ReactNode;
  className?: string;
  targetElement: React.ReactNode;
}

export function getPosition(
  vertical: 'top' | 'bottom',
  horizontal: 'left' | 'right',
) {
  return { vertical, horizontal };
}

export enum PositionOption {
  top = 'top',
  bottom = 'bottom',
  right = 'right',
  left = 'left',
}

const AppMenu: React.FC<AppMenuProps> = ({
  anchorEl,
  onClose,
  align = 'bottom',
  anchorOrigin = getPosition(PositionOption.bottom, PositionOption.right),
  transformOrigin = getPosition(PositionOption.top, PositionOption.right),
  children,
  className,
  targetElement,
}) => {
  const { classes } = useStyles(theme);

  return (
    <ClickAwayListener onClickAway={onClose}>
      <div onClick={(e) => e.stopPropagation()}>
        {targetElement}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={onClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
          classes={{
            paper: clsx(
              classes.menuContainer,
              align !== 'bottom' && classes.alignTop,
              className,
            ),
          }}
          PopoverClasses={{ root: classes.menuBackground }}>
          {children}
        </Menu>
      </div>
    </ClickAwayListener>
  );
};

export default AppMenu;
